import {ClientProviderPreference, extractPsychotherapyAuthorizedHours, Offer, Referral} from "../../domains";
import {PAGE} from "../../const";
import {filterOfferByRecentPage} from "./common";
import {groupBy} from "lodash";
import {ProviderOfferDetailItem} from "./ProviderOfferDetailItem";
import {UnmatchReturnOfferModalState} from "../ProviderOfferReturnedModal";

type providerOfferDetailGridViewColumnProps = {
    offers: Offer[];
    referral: Referral;
    selectedItem: Offer | null;
    setSelectedItem: (offer: Offer | null) => void;
    setUnmatchReturnModalState: (show: UnmatchReturnOfferModalState) => void;
    recentPage: PAGE;
    prefsSibling: ClientProviderPreference[];
};

export function ProviderOfferDetailGridViewColumn({
                                                      referral,
                                                      offers,
                                                      selectedItem,
                                                      setSelectedItem,
                                                      recentPage,
                                                      setUnmatchReturnModalState,
                                                      prefsSibling,
                                                  }: providerOfferDetailGridViewColumnProps) {

    const preferencesByProviderSfIds = groupBy([...prefsSibling, ...referral.clientProviderPreferences], p => p.sfProviderId);

    return (<div className='flex flex-col mr-5'>
        <div className='mb-5 text-xl font-bold leading-5'>
            {referral.clientName}
        </div>
        {
            filterOfferByRecentPage(offers, recentPage).map((offer) =>
                <ProviderOfferDetailItem
                    shortMode={true}
                    key={offer.guid}
                    isSelected={selectedItem !== null && selectedItem.id === offer.id}
                    setSelect={() => setSelectedItem(offer)}
                    showReturnModal={() => setUnmatchReturnModalState('Return')}
                    isMatched={referral.matchedOffer?.guid === offer.guid}
                    offer={offer}
                    recentPage={recentPage}
                    preferences={offer.providerSfId ? preferencesByProviderSfIds[offer.providerSfId] : []}
                    psychotherapyAuthorizedHour={extractPsychotherapyAuthorizedHours(referral)}
                    referralRequiredLanguage={referral.requiredLanguage}/>
            )
        }
    </div>);
}
